module.exports = __webpack_public_path__ + "img/jg_icon.9845c90c.png";